import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import FundingCriteria from "./FundingCriteria";
import { Neo } from "@singularsystems/neo-react";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { ReportCategory } from "../ReportCategory";

@NeoReport("FundingReport",{ category: ReportCategory.CombinedReports })
export default class FundingReport extends Report<FundingCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(FundingCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.FormGroup bind={this.criteria.meta.entityId} select={{ itemSource: this.dataCache.entities }} />
            <Neo.FormGroup bind={this.criteria.meta.allowUnauthorised} label="Allow Unauthorised?"
                footerText="Allows the report to be run when it contains unauthorised records." />
        </div>;
    }
}